import React, { useState, useEffect } from "react";  // Import useState here
import "./DARKHAWK.css";

const DARKHAWK = () => {
  const [loading, setLoading] = useState(true);

  const handleLoad = () => {
    setLoading(false);
  };
  // In DARKHAWK component (or wherever it's triggered)
useEffect(() => {
    document.body.classList.add("darkhawk-active");  // Add class when DARKHAWK is active
    return () => {
      document.body.classList.remove("darkhawk-active");  // Clean up class when leaving DARKHAWK
    };
  }, []);
  

  return (
    <div className="darkhawk-container">
      {/* <h2>Welcome to DARKHAWK</h2> */}
      {loading && <div>Loading...</div>}  {/* Add a loading state */}
      <iframe
        src="http://108.181.202.203:9002/"
        title="DARKHAWK - Social Insight"
        // width="90%"
        // height="300%"
        frameBorder="0"
        style={{ border: "none" }}
        onLoad={handleLoad}  // Mark loading as complete when the iframe has loaded
      />
    </div>
  );
};

export default DARKHAWK;
